<template>
  <div class="mt-4">
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          <h4>{{ $t('view_notification') }}</h4>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-3">
            <v-col md="2" cols="12" class="font-weight-bold">Sent:</v-col>
            <v-col md="10" cols="12">
              <if-set :value="modalViewObject.sent">
                <multi-time-display :time="modalViewObject.sent" />
              </if-set>
            </v-col>
          </v-row>
          <v-row class="mb-3">
            <v-col md="2" cols="12" class="font-weight-bold">Recipient:</v-col>
            <v-col md="10" cols="12">{{ modalViewObject.recipient }}</v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col md="2" cols="12" class="font-weight-bold">Subject:</v-col>
            <v-col md="10" cols="12" class="font-italic">{{ modalViewObject.subject }}</v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col md="2" cols="12" class="font-weight-bold">Body:</v-col>
            <v-col md="10" cols="12" v-html="modalViewObject.body"></v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-dialog>
    <h4>{{ $tc('recent_notifications') }}</h4>
    <v-row>
      <v-col>
        <table-pagination-controls
          :total-rows="remoteData.totalRows"
          :current-page.sync="remoteData.currentPage"
          :rows-per-page.sync="remoteData.rowsPerPage"
          @update:currentPage="refreshResults"
          @update:rowsPerPage="initiateSearch"
          :per-page-options="remoteData.pageOptions"/>
        <v-data-table
          hide-default-footer
          class="vf-table mt-2"
          :headers="tableFields"
          :items="remoteData.items"
          :server-items-length="remoteData.totalRows"
          :sort-by.sync="remoteData.sortBy"
          :sort-desc.sync="remoteData.sortDesc"
          :loading="remoteData.isBusy"
          :loading-text="$t('loading')"
          @update:sort-by="initiateSearch()"
          @update:sort-desc="initiateSearch()">

          <template #item.sent="row">
            <if-set :value="row.item.sent">
              <multi-time-display :time="row.item.sent" />
            </if-set>
          </template>
          <template #item.subject="row">
            <template>
              <a href="#" @click="showNotification(row.item)">
                {{ $t(row.value) }}
              </a>
            </template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import RemoteDataTableMixin from '@/components/mixins/RemoteDataTableMixin'
import BrowserUtilitiesMixin from '@/components/mixins/BrowserUtilitiesMixin'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay.vue'
import TablePaginationControls from '@/components/shared/TablePaginationControls'
import IfSet from '@/components/shared/IfSet'

export default {
  name: 'RecentNotificationIndex',
  mixins: [CurrentUserMixin, RemoteDataTableMixin, BrowserUtilitiesMixin],
  components: {
    MultiTimeDisplay,
    TablePaginationControls,
    IfSet
  },
  mounted () {
    this.initiateSearch()
  },
  data () {
    return {
      model: 'Notification',
      searchCriteria: {},
      dialog: false,
      tableFields: [
        {
          value: 'sent',
          text: this.$tc('sent'),
          sortable: true
        },
        {
          value: 'subject',
          text: this.$tc('subject'),
          sortable: true
        }
      ],
      modalViewObject: {
        sent: null,
        recipient: null,
        subject: null,
        body: null
      }
    }
  },
  methods: {
    buildSearchCriteria () {
      const searchCriteria = {
        sent_after: '-1 day',
        page: this.remoteData.currentPage,
        'per-page': this.remoteData.rowsPerPage,
        user_id: this.user.id
      }
      if (this.remoteData.sortBy !== null) {
        const sortDirection = this.remoteData.sortDesc ? '-' : ''
        searchCriteria.sort = `${sortDirection}${this.remoteData.sortBy}`
      }
      return searchCriteria
    },
    showNotification (item) {
      this.modalViewObject = item
      this.dialog = true
    }
  }
}
</script>

<style scoped>

</style>
